import "../styles/waitlistlandingpage.css"
import { Link } from "react-router-dom";


export default function WaitListLandingPage() {
  return (
    
    <div className="success-wrapper">
      <h1 className="success-title">Danke für deine Anmeldung! 🎉</h1>
      <p className="success-text">Du bist nun auf der Warteliste. Wir melden uns bald bei dir per E-Mail.</p>
      <Link to="/" className="success-button">Zur Startseite</Link>
    </div>

  );
}